/** Nothing to show. Says what would put something here, not just "no data". */
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  /** What the user would do to fill this. */
  description?: ReactNode;
  /** A primary action, usually a button or a link. */
  action?: ReactNode;
  /** A short glyph or emoji-free mark. Defaults to a neutral dash mark. */
  icon?: ReactNode;
  /** Tightens the padding, for an empty panel inside a small card. */
  compact?: boolean;
  className?: string;
}

export function EmptyState({
  title,
  description,
  action,
  icon,
  compact = false,
  className,
}: EmptyStateProps) {
  const classes = ['empty-state', compact ? 'empty-compact' : '', className].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      <div className="empty-mark" aria-hidden="true">
        {icon ?? <CompassGlyph />}
      </div>
      <strong>{title}</strong>
      {description !== undefined && <p className="empty-description">{description}</p>}
      {action !== undefined && <div className="empty-action">{action}</div>}
    </div>
  );
}

function CompassGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="9" />
      <path d="M15.5 8.5 13 13l-4.5 2.5L11 11z" strokeLinejoin="round" />
    </svg>
  );
}

export default EmptyState;
